class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.item = $(this).closest('.productView');
        this.isFullWidth = this.item.is('.layout-4');
        console.log('Check 2');
        this.onVariantInit();
        this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantInit(){
        this.updateOptions();
        this.updateMasterId();
        this.updateMedia(1500);
        // this.updateURL();
        this.renderProductAjaxInfo();
        this.renderProductInfo();
        if (!this.currentVariant) {
            this.updateAttribute(true);
        } else {
            this.updateAttribute(false, !this.currentVariant.available);
        }
        this.updateVariantStatuses();
        this.updateStickyAddToCart(false, !this.currentVariant?.available);

    }
    
    onVariantChange(event) {
        this.updateOptions();
        this.updateMasterId();
        this.updatePickupAvailability();
        this.updateVariantStatuses();

        updateSizeLabels(this.currentVariant);
        setTimeout(updateHeaderSizeLabels, 1);
      
        if (!this.currentVariant) {
            this.updateAttribute(true);
            this.updateStickyAddToCart(true);
        } else {
            this.updateMedia(200);
            this.updateURL();
            this.updateVariantInput();
            this.renderProductAjaxInfo();
            this.renderProductInfo();
            this.updateProductInfo();
            this.updateAttribute(false, !this.currentVariant.available);
            this.updateStickyAddToCart(false, !this.currentVariant.available);
            this.checkQuantityWhenVariantChange();
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    decodeOptions() {
        this.options = this.options.map(option => {
            const parsedOption = this.decodeOption(option)
            return parsedOption
        })
    }
  
    decodeOption(option) {
      if (option) {
          return option.split('Special_Double_Quote').join('"').split('Special_Slash').join('/')
        } else {
          return null
        }
    }

    encodeOption(option) {
        if (option) {
          return option.split('"').join('Special_Double_Quote').split('/').join('Special_Slash')
        } else {
          return null
        }
    }
    
    updateMasterId() {
        this.decodeOptions()
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }      

    updateMedia(time) {
        if (!this.currentVariant || !this.currentVariant?.featured_media) return;
        
        const newMedia = document.querySelectorAll(
            `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );

        if (!newMedia) return;
        window.setTimeout(() => {
            $(newMedia).trigger('click');
        }, time);

        if (!this.isFullWidth || window.innerWidth < 768) return;

        const mediaToReplace = document.querySelector('.productView-image[data-index="1"]');
        const imageToReplace = mediaToReplace.querySelector('img')

        if (!this.currentVariant) return;

        const image = this.currentVariant?.featured_image;

        if (image == null) return;

        imageToReplace.setAttribute('src',  image.src)
        imageToReplace.setAttribute('srcset', image.src)
        imageToReplace.setAttribute('alt', image.alt)

        // if (mediaToReplace.getBoundingClientRect().top < window.scrollY) {
        //     this.scrollToBlock(mediaToReplace)
        // }
    }

    scrollToBlock(block) {
        const headerHeight = document.querySelectorAll('.section-header-navigation')[0]?.getBoundingClientRect().height 
        const announcementBarHeight = document.querySelectorAll('.announcement-bar')[0]?.getBoundingClientRect().height 
        const positionTop = block.getBoundingClientRect().top - headerHeight - announcementBarHeight 

        window.scrollTo({
            top: positionTop,
            behavior: 'smooth'
        })
    }

    updateURL() {
        if (!this.currentVariant) return;
        window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.product}, #product-form-installment-${this.dataset.product}`);

        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant?.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    renderProductAjaxInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const id = `product-price-${this.dataset.product}`;
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destination = document.getElementById(id);
                const source = html.getElementById(id);

                const property = `product-property-${this.dataset.product}`;
                const destinationProperty = document.getElementById(property);
                const sourceProperty = html.getElementById(property);

                if (source && destination) {
                    destination.innerHTML = source.innerHTML;
                }

                if (this.checkNeedToConvertCurrency()) {
                    let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');

                    Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                }

                if(destinationProperty) {
                    if (sourceProperty) {
                        destinationProperty.innerHTML = sourceProperty.innerHTML;
                        destinationProperty.style.display = 'table';
                    } else{
                        destinationProperty.style.display = 'none';
                    }
                } else if (sourceProperty) {
                    document.querySelector('.productView-product').insertBefore(sourceProperty, document.querySelector('.productView-options'));
                }

                document.getElementById(`product-price-${this.dataset.product}`)?.classList.remove('visibility-hidden');
        });
    }

    renderProductInfo() {
        if(this.item.find('[data-sku]').length > 0){
            this.item.find('[data-sku] .productView-info-value').text(this.currentVariant.sku);
        }

        var inventory = this.currentVariant?.inventory_management;

        if(inventory != null) {
            var arrayInVarName = `product_inven_array_${this.dataset.product}`,
                inven_array = window[arrayInVarName];

            if(inven_array != undefined) {
                var inven_num = inven_array[this.currentVariant.id],
                    inventoryQuantity = parseInt(inven_num);

                this.item.find('input[name="quantity"]').attr('data-inventory-quantity', inventoryQuantity);

                if(this.item.find('[data-inventory]').length > 0){
                    if(inventoryQuantity > 0){
                        const showStock = this.item.find('[data-inventory]').data('stock-level');
                        if (showStock == 'show') {
                            this.item.find('[data-inventory] .productView-info-value').text(inventoryQuantity+' '+window.inventory_text.inStock);
                        }
                        else {
                            this.item.find('[data-inventory] .productView-info-value').text(window.inventory_text.inStock);
                        }
                    } else {
                        this.item.find('[data-inventory] .productView-info-value').text(window.inventory_text.outOfStock);
                    }
                }

                hotStock(inventoryQuantity);
            }
        }

        if(this.item.find('.productView-stickyCart').length > 0){
            const sticky = this.item.find('.productView-stickyCart');
            const optionSticky = sticky.find('.select__select');

            optionSticky.val(this.currentVariant.id);
        }
    }

    updateProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const description = `[data-product-description-${this.dataset.product}]`
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destinationDesc = document.querySelector(description);
                const sourceDesc = html.querySelector(description);

                if (sourceDesc && destinationDesc) {
                    destinationDesc.innerHTML = sourceDesc.innerHTML;
                    if (destinationDesc.closest('.toggle-content--height')){
                        destinationDesc.style.maxHeight = null;
                    }
                }
        });
    }

    updateAttribute(unavailable = true, disable = true){
        let holidayModeElements = document.getElementsByClassName(`holiday-mode-wrapper`);
        let holidayModeWrapper;
        if(holidayModeElements.length > 0){
          holidayModeWrapper = holidayModeElements[0];
        }
        //const holidayModeWrapper = document.getElementById(`holiday-mode-wrapper`);
        const addButton = document.getElementById(`product-form-${this.dataset.product}`)?.querySelector('[name="add"]');
        var quantityInput = this.item.find('input[name="quantity"]'),
            notifyMe = this.item.find('.productView-notifyMe'),
            hotStock = this.item.find('.productView-hotStock'),
            buttonAddtocart = this.item.find('.product-form__submit'),
            maxValue = parseInt(quantityInput.attr('data-inventory-quantity')),
            outOfStockMessage = document.querySelector('.outofstock-message');

        if (isNaN(maxValue)) {
            maxValue = maxValue = parseInt(buttonAddtocart.attr('data-inventory-quantity'));
        } else {
            maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));
        }
        
        if(unavailable){

           if (outOfStockMessage) {
            outOfStockMessage.innerHTML = '';
          }

            var text = window.variantStrings.unavailable;

            quantityInput.attr('disabled', true);
            notifyMe.slideUp('slow');
            addButton.setAttribute('disabled', true);
            addButton.textContent = text;
            (holidayModeWrapper) ? holidayModeWrapper.style.display = "none" : null;
            quantityInput.closest('quantity-input').addClass('disabled');

            if(hotStock.length > 0) hotStock.addClass('is-hiden');
        } else {
            if (disable) {
               if (outOfStockMessage) {
                document.querySelector('.outofstock-message').innerHTML = `Selected (${this.currentVariant.title}) is out of stock. Choose from available sizes.`;
               }
                var text = window.variantStrings.soldOut;

                quantityInput.attr('data-price', this.currentVariant?.price);
                quantityInput.attr('disabled', true);
                addButton.setAttribute('disabled', true);
                addButton.textContent = text;
                (holidayModeWrapper) ? holidayModeWrapper.style.display = "none" : null;
                quantityInput.closest('quantity-input').addClass('disabled');

                if(notifyMe.length > 0){
                    notifyMe.find('input[name="halo-notify-product-variant"]').val(this.currentVariant.title);
                    notifyMe.find('.notifyMe-text').empty();
                    notifyMe.slideDown('slow');
                }
            } else{

                if (outOfStockMessage) {
                  outOfStockMessage.innerHTML = '';
                }
                
                var text,
                    subTotal = 0,
                    price = this.currentVariant?.price;

                const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');
                const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');

                if(window.subtotal.show) {
                    let qty = quantityInput.val();

                    subTotal = qty * price;
                    subTotal = Shopify.formatMoney(subTotal, window.money_format);
                    subTotal = extractContent(subTotal);

                    const moneySpan = document.createElement('span')
                    moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal') 
                    moneySpan.innerText = subTotal 
                    document.body.appendChild(moneySpan) 

                    if (this.checkNeedToConvertCurrency()) {
                        let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                        Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                    }
                    
                    subTotal = moneySpan.innerText 
                    $(moneySpan).remove()

                    if (window.subtotal.style == '1') {
                        const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');
                       if (pdView_subTotal != null) {
                         pdView_subTotal.textContent = subTotal;
                       }
                      
                        if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                            text = window.variantStrings.preOrder;
                        } else {
                            text = window.variantStrings.addToCart;
                        }
                    }
                    else if (window.subtotal.style == '2') {
                        text = window.subtotal.text.replace('[value]', subTotal);
                    }
                } else {
                    subTotal = Shopify.formatMoney(price, window.money_format);
                    subTotal = extractContent(subTotal);
                    if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                        text = window.variantStrings.preOrder;
                    } else {
                        text = window.variantStrings.addToCart;
                    }
                }

                quantityInput.attr('data-price', this.currentVariant?.price);
                quantityInput.attr('disabled', false);
                if(addButton){
                addButton.removeAttribute('disabled');
                addButton.textContent = text;
                

                const productIdInput = document.querySelector('[name="product-id"]');
                const productId = productIdInput ? productIdInput.getAttribute('value') : null;
                const inventoryArray = productId ? window['product_inven_array_' + productId] : null;
                const inventoryQty = parseInt(inventoryArray ? inventoryArray[this.currentVariant.id] : 0) || 0;
                const inventoryPolicy = this.currentVariant.inventory_management ? this.currentVariant.inventory_management : '';

                addButton.setAttribute('data-inventory-quantity', inventoryQty);
                addButton.setAttribute('data-inventory-policy', inventoryPolicy);

                }

                (holidayModeWrapper) ? holidayModeWrapper.style.display = "block" : null;
                quantityInput.closest('quantity-input').removeClass('disabled');

                if (subTotal != 0 && stickyPrice.length) {
                    stickyPrice.text(subTotal);
                }

                if (subTotal != 0 && stickyComparePrice.length && window.subtotal.show) {
                    let comparePrice = $('[data-sticky-add-to-cart] .money-compare-price').data('compare-price'),
                        qty = quantityInput.val();
                    comparePrice = qty * comparePrice;
                    comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
                    comparePrice = extractContent(comparePrice);
                    stickyComparePrice.text(comparePrice);
                }

                if(notifyMe.length > 0){
                    notifyMe.slideUp('slow');
                }
            }
        }
    }

    // updateStickyAddToCart(unavailable = true, disable = true){
    //     if(this.item.find('.productView-stickyCart').length > 0){
    //         const sticky = this.item.find('.productView-stickyCart');
    //         const itemImage = sticky.find('.sticky-image');
    //         const option = sticky.find('.select__select');
    //         const input = document.getElementById(`product-form-sticky-${this.dataset.product}`)?.querySelector('input[name="id"]');
    //         const button = document.getElementById(`product-form-sticky-${this.dataset.product}`)?.querySelector('[name="add"]');
    //         var quantityInput = this.item.find('input[name="quantity"]');
    //         var maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));
          
    //         if(unavailable){
    //             var text = window.variantStrings.unavailable;

    //             button.setAttribute('disabled', true);
    //             button.textContent = text;
    //         } else {
    //             if (!this.currentVariant) return;

    //             const image = this.currentVariant?.featured_image;
                
    //             if (image != null) {
    //                 itemImage.find('img').attr({
    //                     'src': image.src,
    //                     'srcset': image.src,
    //                     'alt': image.alt
    //                 });
    //             }

    //             option.val(this.currentVariant.id);

    //             if (disable) {
    //                 var text = window.variantStrings.soldOut;

    //                 button.setAttribute('disabled', true);
    //                 button.textContent = text;
    //             } else {
    //                 if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
    //                     text = window.variantStrings.preOrder;
    //                 } else {
    //                     text = window.variantStrings.addToCart;
    //                 }

    //                 button.removeAttribute('disabled');
    //                 button.textContent = text;
    //             }

    //             input.value = this.currentVariant.id;
    //             input.dispatchEvent(new Event('change', { bubbles: true }));
    //         }
    //     }
    // }

updateStickyAddToCart(unavailable = true, disable = true) {
  if (this.item.find('.productView-stickyCart').length === 0) return;

  const sticky = this.item.find('.productView-stickyCart');
const itemImage = sticky.find('.sticky-image');
const option = sticky.find('.select__select');
const input = document
  .getElementById(`product-form-sticky-${this.dataset.product}`)
  ?.querySelector('input[name="id"]');
const button = document
  .getElementById(`product-form-sticky-${this.dataset.product}`)
  ?.querySelector('[name="add"]');

  const quantityInput = this.item.find('input[name="quantity"]');
  const maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));
  const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');
  const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');

  // ✅ Ensure we have a valid variant (fallback for initial page load)
  if (!this.currentVariant) {
    const variants = this.getVariantData();
    if (variants && variants.length > 0) {
      this.currentVariant = variants.find(v => v.available) || variants[0];
    }
  }

  // Still no variant? Exit safely
  if (!this.currentVariant) return;

  if (unavailable) {
    const text = window.variantStrings.unavailable;
    button.setAttribute('disabled', true);
    button.textContent = text;
    return;
  }

  const image = this.currentVariant?.featured_image;
  if (image != null) {
    itemImage.find('img').attr({
      src: image.src,
      srcset: image.src,
      alt: image.alt,
    });
  }

  option.val(this.currentVariant.id);

  // ✅ Update sticky subtotal price dynamically
  const qty = parseInt(quantityInput.val()) || 1;
  const price = this.currentVariant?.price || 0;
  let subTotal = Shopify.formatMoney(qty * price, window.money_format);
  subTotal = extractContent(subTotal);

  // Currency conversion
  const moneySpan = document.createElement('span');
  moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal');
  moneySpan.innerText = subTotal;
  document.body.appendChild(moneySpan);
  if (this.checkNeedToConvertCurrency()) {
    const currencyCode = document
      .getElementById('currencies')
      ?.querySelector('.active')
      ?.getAttribute('data-currency');
    Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
  }
  subTotal = moneySpan.innerText;
  $(moneySpan).remove();

  if (stickyPrice.length) {
    stickyPrice.text(subTotal);
  }

  // Compare price if available
  if (stickyComparePrice.length && this.currentVariant.compare_at_price > price) {
    let compareSubTotal = Shopify.formatMoney(
      qty * this.currentVariant.compare_at_price,
      window.money_format
    );
    compareSubTotal = extractContent(compareSubTotal);
    stickyComparePrice.text(compareSubTotal);
  }

  // ✅ Button state logic
  let text;
  if (disable) {
    text = window.variantStrings.soldOut;
    button.setAttribute('disabled', true);
  } else {
    if (
      this.currentVariant.available &&
      maxValue <= 0 &&
      this.currentVariant.inventory_management === 'shopify'
    ) {
      text = window.variantStrings.preOrder;
    } else {
      text = window.variantStrings.addToCart;
    }
    button.removeAttribute('disabled');
  }
  button.textContent = text;

  // ✅ Ensure input updates properly
  if (input) {
    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}


    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    checkNeedToConvertCurrency() {
        var currencyItem = $('.dropdown-item[data-currency]');
        if (currencyItem.length) {
            return (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
        } else {
            return;
        }
    }

    checkQuantityWhenVariantChange() {
        var quantityInput = this.closest('.productView-details').querySelector('input.quantity__input')
        var maxValue = parseInt(quantityInput?.dataset.inventoryQuantity);
        var inputValue = parseInt(quantityInput?.value);

        let value = inputValue 

        if (inputValue > maxValue && maxValue > 0) {
            value = maxValue
        } else {
            value = inputValue
        }

        if (value < 1 || isNaN(value)) value = 1 
      
        if (quantityInput) {
          quantityInput.value = value
        }
      
        document.getElementById('product-add-to-cart').dataset.available = this.currentVariant.available && maxValue <= 0
    }

    updateVariantStatuses() {
        // const options = this.item.find('.productView-details .product-form__input'),
        //     optionsLength = options.length,
        //     pvOptionsLength = PVoptions.length,
        //     checkStickyVariant = false;
      
        // optionsLength > pvOptionsLength ? checkStickyVariant = true : '';

        const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];
        const inputLength = inputWrappers.length;
        inputWrappers.forEach((option, index) => {
            option.querySelector('[data-header-option]').innerText = option.querySelector(':checked').dataset.legendValue;
            if (index === 0 && inputLength > 1) return;
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
            const previousOptionSelected = inputLength > 1 ? inputWrappers[index - 1].querySelector(':checked').value : inputWrappers[index].querySelector(':checked').value;
            const optionInputsValue = inputLength > 1 ? selectedOptionOneVariants.filter(variant => variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]) : this.variantData.map(variantOption => variantOption[`option${ index + 1 }`]);
            const availableOptionInputsValue = inputLength > 1 ? selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]) : this.variantData.filter(variant => variant.available).map(variantOption => variantOption[`option${ index + 1 }`]);
            this.setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue)
        });
        
        setTimeout(updateHeaderSizeLabels, 1);
    }

    setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue) {
        optionInputs.forEach(input => {
            if (availableOptionInputsValue.includes(input.getAttribute('value'))) {
                input.classList.remove('soldout');
                input.innerText = input.getAttribute('value');
            } else {
                input.classList.add('soldout');
                optionInputsValue.includes(input.getAttribute('value')) ? input.innerText = input.getAttribute('value') + ' (Sold out)' : input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'))
            }
        });
    }
}

customElements.define('variant-selects', VariantSelects);



window.sizeMap = {
  "4":  { EU: 32, US: 1,  UK: 4 },
  "6":  { EU: 34, US: 2,  UK: 6 },
  "8":  { EU: 36, US: 4,  UK: 8 },
  "10": { EU: 38, US: 6,  UK: 10 },
  "12": { EU: 40, US: 8,  UK: 12 },
  "14": { EU: 42, US: 10, UK: 14 },
  "16": { EU: 44, US: 12, UK: 16 },
  "18": { EU: 46, US: 14, UK: 18 },
  "20": { EU: 48, US: 16, UK: 20 },
  "22": { EU: 50, US: 18, UK: 22 },
  "24": { EU: 52, US: 20, UK: 24 },
  "26": { EU: 54, US: 22, UK: 26 },
  "28": { EU: 56, US: 24, UK: 28 }
};

function isSizeMapFalse() {
  const el = document.querySelector(".productView-options");
  return el?.dataset.sizeMaping === "false";
}


function updateSizeLabels() {
  const region = window.userSizeRegion;
  if (isSizeMapFalse()) return;
  if (region === "DEFAULT") return;

  document.querySelectorAll('.custom-select-size-option input[type="radio"]').forEach(input => {
    const size = input.value.trim();
    const map = window.sizeMap[size];
    if (!map) return;

    // ⭐ UK custom formatting
    let formatted;
    if (region === "UK") {
      formatted = `UK ${map[region]}`;
    } else {
      formatted = `${size} (${region} ${map[region]})`;
    }

    const label = input.nextElementSibling;
    if (!label) return;

    const textEl = label.querySelector('.text');
    if (!textEl) return;

    const firstNode = [...textEl.childNodes].find(
      node => node.nodeType === Node.TEXT_NODE
    );

    if (firstNode) {
      firstNode.textContent = formatted + " ";
    }

    input.dataset.legendValue = formatted;
  });

  setTimeout(updateHeaderSizeLabels, 1);
}



function updateHeaderSizeLabels() {
  const region = window.userSizeRegion;
  if (isSizeMapFalse()) return;
  if (region === "DEFAULT") return;

  document.querySelectorAll('.custom-select-for-sizes').forEach(fieldset => {
    const selected = fieldset.querySelector('input[type="radio"]:checked');
    const header = fieldset.querySelector('[data-header-option]');
    const headerwarpper = fieldset.querySelector('.option-name-header');

    if (!selected || !header) return;

    const size = selected.value.trim();
    const map = window.sizeMap[size];
    if (!map) return;

    // ⭐ UK custom formatting
    let formatted;
    if (region === "UK") {
      formatted = `UK ${map[region]}`;
    } else {
      formatted = `${size} (${region} ${map[region]})`;
    }

    const isSoldOut = selected.nextElementSibling?.classList.contains('soldout');

    // ⭐ Header Output
    header.textContent = isSoldOut
      ? `${formatted} - Out Of Stock`
      : formatted;

    headerwarpper.classList.add('ipsizechange');
  });
}



window.userSizeRegion = "DEFAULT";

fetch("https://pro.ip-api.com/json/?key=XjCy8wkn8k9YuLG&fields=status,country,countryCode")
  .then(r => r.json())
  .then(data => {
    if (data.status !== "success") return;

    const cc = data.countryCode;

    // EU
    if (["FR","DE","NL","SE","ES","PL","IT","FI","DK","BE","AT","PT","IE","GR","LU","CZ","HU","SK","SI","EE","LV","LT"].includes(cc)) {
      window.userSizeRegion = "EU";
      document.body.classList.add('ipsizes');
    }
    // US
    else if (cc === "US") {
      window.userSizeRegion = "US";
      document.body.classList.add('ipsizes');
    }
    // ⭐ UK
    else if (cc === "GB") {
      window.userSizeRegion = "UK";
      document.body.classList.add('ipsizes');
    }

    updateSizeLabels();
  });


class VariantRadios extends VariantSelects {
  constructor() {
    super();
    // Cache this once
    this.hasVariantInUrl = new URLSearchParams(window.location.search).has('variant');

    if (!this.hasVariantInUrl) {
      const sizeFieldset = this.querySelector('fieldset.custom-select-for-sizes');
      if (sizeFieldset) {
        const checkedRadio = sizeFieldset.querySelector('input[type="radio"]:checked');
        if (checkedRadio) {
          this.hasVariantInUrl = true;
        }
      }
    }
    
  }

  connectedCallback() {
    super.connectedCallback?.();

    // Open/close dropdown
    this.addEventListener('click', e => {
      const legend = e.target.closest('.custom-select-for-sizes .form__label');
      const isMobile = window.matchMedia('(max-width: 768px)').matches;

      // Close button (mobile)
      const closeBtn = e.target.closest('#close-custom-select');
      if (closeBtn) {
        const fieldset = closeBtn.closest('.custom-select-for-sizes');
        if (fieldset) fieldset.classList.remove('active');
        document.body.classList.remove('showing-size-select');
        return;
      }

      if (!legend) return;
      e.stopPropagation();

      const fieldset = legend.closest('.custom-select-for-sizes');
      if (!fieldset) return;

      // Close others
      document.querySelectorAll('.custom-select-for-sizes.active').forEach(el => {
        if (el !== fieldset) el.classList.remove('active');
      });

      // When opening and NO ?variant= → clear radios + reset legends + disable ATC
      if (!fieldset.classList.contains('active') && !this.hasVariantInUrl) {
        const radios = fieldset.querySelectorAll('input[type="radio"]');
        radios.forEach(r => (r.checked = false));
        
        const hiddenLegend = fieldset.querySelector('.hidden-legend');
        const selectLegend = fieldset.querySelector('.select-the-size');
        
        if (hiddenLegend) hiddenLegend.style.display = 'none';
        if (selectLegend) selectLegend.style.display = 'flex';
        this.enableAddToCart(false);
      }

      // Toggle current
      fieldset.classList.toggle('active');

      // Mobile overlay
      if (isMobile) {
        document.body.classList.toggle('showing-size-select', fieldset.classList.contains('active'));
      }
    });

    // Click outside closes (both modes)
    document.addEventListener('click', e => {
      if (!e.target.closest('.custom-select-for-sizes')) {
        document.querySelectorAll('.custom-select-for-sizes').forEach(fs => fs.classList.remove('active'));
        document.body.classList.remove('showing-size-select');
      }
    });

    // Selection handler
    this.addEventListener('change', e => {
      const target = e.target;
      if (!target.matches('.custom-select-for-sizes input[type="radio"]')) return;

      // Run full variant change flow
      this.onVariantChange(e);
      updateSizeLabels();

      const fieldset = target.closest('.custom-select-for-sizes');
      const isMobile = window.matchMedia('(max-width: 768px)').matches;
      const legendValue = fieldset.querySelector('[data-header-option]');
      const hiddenLegend = fieldset.querySelector('.hidden-legend');
      const selectLegend = fieldset.querySelector('.select-the-size');

      // Legend text (use data-legend-value if provided)
      const legendText = target.dataset.legendValue || target.value;
      if (legendValue) legendValue.textContent = legendText;

      // Show selected legend
      if (selectLegend) selectLegend.style.display = 'none';
      if (hiddenLegend) hiddenLegend.style.display = 'block';

      // Button state (Sold out / Add to Bag)
      const isSoldOut = !this.currentVariant?.available;
      this.enableAddToCart(!isSoldOut, isSoldOut);

      // Desktop: close after selection; Mobile: keep open
      if (!isMobile) {
        fieldset.classList.remove('active');
        document.body.classList.remove('showing-size-select');
      }
    });

    // Initialize legends & ATC based on ?variant=
    this.handleInitialLegendDisplay();
  }

  handleInitialLegendDisplay() {
    const fieldsets = this.querySelectorAll('.custom-select-for-sizes');
    
    fieldsets.forEach(fieldset => {
      const hiddenLegend = fieldset.querySelector('.hidden-legend');
      const selectLegend = fieldset.querySelector('.select-the-size');

      if (this.hasVariantInUrl) {
        // Keep selected, show hidden-legend
        if (selectLegend) selectLegend.style.display = 'none';
        if (hiddenLegend) hiddenLegend.style.display = 'block';
        
        const isSoldOut = !this.currentVariant?.available;
        this.enableAddToCart(!isSoldOut, isSoldOut);
      } else {
        // Force selection by user
        if (selectLegend) selectLegend.style.display = 'flex';
        if (hiddenLegend) hiddenLegend.style.display = 'none';
        this.enableAddToCart(false);
      }
    });
  }

  enableAddToCart(enable, isSoldOut = false) {
    const addButton = document.querySelector('[name="add"]');
    if (!addButton) return;

    if (isSoldOut) {
      addButton.setAttribute('disabled', true);
      addButton.classList.add('disabled');
      addButton.textContent = window.variantStrings?.soldOut || 'Sold Out';
      return;
    }

    if (enable) {
      addButton.removeAttribute('disabled');
      addButton.classList.remove('disabled');
      addButton.textContent = window.variantStrings?.addToCart || 'Add to Bag';
    } else {
      addButton.setAttribute('disabled', true);
      addButton.classList.add('disabled');
      addButton.textContent = window.variantStrings?.select_size || 'Select the Size';
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    
    this.options = fieldsets.map(fieldset => {
      if (fieldset.classList.contains('custom-select-for-sizes')) {
        const selected = fieldset.querySelector('input[type="radio"]:checked');
        return selected ? selected.value : null;
      } else {
        const checkedRadio = Array.from(fieldset.querySelectorAll('input[type="radio"]'))
          .find(radio => radio.checked);
        return checkedRadio ? checkedRadio.value : null;
      }
    });
  }

  setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue) {
  optionInputs.forEach(input => {
    const label = input.nextElementSibling;
    const isCustomSelect = input.closest('.custom-select-for-sizes');
    if (!label) return;

    const valueText = input.getAttribute('value');
    const isAvailable = availableOptionInputsValue.includes(valueText);

    if (isAvailable) {
      label.classList.remove('soldout', 'unavailable');
      label.classList.add('available');
      if (isCustomSelect && label.querySelector('.text')) {
        label.querySelector('.text').innerHTML = valueText; // ✅ keep clean
      }
    } else {
      label.classList.remove('available', 'unavailable');
      label.classList.add('soldout');

      // ✅ Properly preserve SVG + spans
      const textHTML = `
        ${valueText}
        <span class="outofstocklabel-desktop">- Out of stock</span>
        <span class="outofstockenvlope-mobile" title="Out of Stock">
          <svg fill="#000000" width="800px" height="800px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19,4H5A3,3,0,0,0,2,7V17a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V7A3,3,0,0,0,19,4ZM5,6H19a1,1,0,0,1,1,1l-8,4.88L4,7A1,1,0,0,1,5,6ZM20,17a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V9.28l7.48,4.57a1,1,0,0,0,1,0L20,9.28Z"/></svg>
        </span>
      `;

      if (isCustomSelect && label.querySelector('.text')) {
        label.querySelector('.text').innerHTML = textHTML; // ✅ preserves SVG
      }
    }
  });
}

}

customElements.define('variant-radios', VariantRadios);


class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true });
        this.input.addEventListener('change', this.onInputChange.bind(this));

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );

        if (!this.checkHasMultipleVariants()) {
            this.initProductQuantity();
            this.checkVariantInventory();
        }
    }

    onInputChange(event) {
        event.preventDefault(); 
        var inputValue = this.input.value;
        var maxValue = parseInt(this.input.dataset.inventoryQuantity);
        var currentId = document.getElementById(`product-form-${this.input.dataset.product}`)?.querySelector('[name="id"]')?.value;
        var saleOutStock  = document.getElementById('product-add-to-cart').dataset.available === 'true' || false ;
        const addButton = document.getElementById(`product-form-${this.input.dataset.product}`)?.querySelector('[name="add"]');

        if(inputValue < 1) {
            inputValue = 1;

            this.input.value =  inputValue;
        }
        
        if (inputValue > maxValue && !saleOutStock && maxValue > 0) {
            var arrayInVarName = `selling_array_${this.input.dataset.product}`,
                itemInArray = window[arrayInVarName],
                itemStatus = itemInArray[currentId];
          
            if(itemStatus == 'deny') {
              inputValue = maxValue
              this.input.value = inputValue;
              const message = getInputMessage(maxValue)
              showWarning(message, 3000)
            }
        } else if (inputValue > maxValue && saleOutStock && maxValue <= 0) {
            this.input.value = inputValue;
        }

        if(window.subtotal.show) {
            var text,
                price = this.input.dataset.price,
                subTotal = 0;

            var parser = new DOMParser();

            subTotal = inputValue * price;
            subTotal = Shopify.formatMoney(subTotal, window.money_format);
            subTotal = extractContent(subTotal);

            const moneySpan = document.createElement('span')
            moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal') 
            moneySpan.innerText = subTotal 
            document.body.appendChild(moneySpan) 

            if (this.checkNeedToConvertCurrency()) {
                let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
            }

            subTotal = moneySpan.innerText 
            $(moneySpan).remove()

            if (window.subtotal.style == '1') {
                const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');

                pdView_subTotal.textContent = subTotal;
            }
            else if (window.subtotal.style == '2') {
                text = window.subtotal.text.replace('[value]', subTotal);

                addButton.textContent = text;  
            }

            const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');
            const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');

            if (stickyPrice.length) {
                stickyPrice.text(subTotal);
            }

            if (stickyComparePrice.length && window.subtotal.show) {
                let comparePrice = $('[data-sticky-add-to-cart] .money-compare-price').data('compare-price');
                comparePrice = inputValue * comparePrice;
                comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
                comparePrice = extractContent(comparePrice);
                stickyComparePrice.text(comparePrice);
            }
        }

        if (this.classList.contains('quantity__group--2') || this.classList.contains('quantity__group--3')) {
            const mainQty = document.querySelector('.quantity__group--1 .quantity__input');
            mainQty.value = inputValue;

            const mainQty2Exists = !!document.querySelector('.quantity__group--2 .quantity__input');
            const mainQty3Exists = !!document.querySelector('.quantity__group--3 .quantity__input');

            if (this.classList.contains('quantity__group--2') && mainQty3Exists) {
                const mainQty3 = document.querySelector('.quantity__group--3 .quantity__input');
                mainQty3.value = inputValue;
            }
            else if (this.classList.contains('quantity__group--3') && mainQty2Exists) {
                const mainQty2 = document.querySelector('.quantity__group--2 .quantity__input');
                mainQty2.value = inputValue;
            }
        }
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        
        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }

    checkNeedToConvertCurrency() {
        return (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
    }
    
    checkHasMultipleVariants() {
        const arrayInVarName = `product_inven_array_${this.querySelector('[data-product]').dataset.product}`
        this.inven_array = window[arrayInVarName];
        return Object.keys(this.inven_array).length > 1
    }
        
    initProductQuantity() {
        if(this.inven_array != undefined) {
            var inven_num = Object.values(this.inven_array),
                inventoryQuantity = parseInt(inven_num);

            this.querySelector('input[name="quantity"]').setAttribute('data-inventory-quantity', inventoryQuantity);
            this.querySelector('input[name="quantity"]').dataset.inventoryQuantity = inventoryQuantity
        }
    }

    checkVariantInventory() {
        const addBtn = document.getElementById('product-add-to-cart')
        this.input.disabled = addBtn.disabled 
        this.querySelector('.btn-quantity.minus').disabled = addBtn.disabled
        this.querySelector('.btn-quantity.plus').disabled = addBtn.disabled
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(document.querySelector('.product-option [type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('quantity-input', QuantityInput);

function hotStock(inventoryQuantity) {
    const productView = document.querySelector('.productView');
    const hotStock = productView.querySelector('.productView-hotStock');
    const hotStockMobile = productView.querySelector('.productView-hotStock-mobile');
    if(hotStock) {
        let hotStockText = hotStock.querySelector('.hotStock-text'),
            hotStockTextMobile = hotStockMobile.querySelector('.hotStock-text'),
            maxStock = parseFloat(hotStock.dataset.hotStock),
            textStock;
            

        if(inventoryQuantity > 0 && inventoryQuantity <= maxStock){
            hotStock.matches('.style-2') ? textStock  = window.inventory_text.hotStock2.replace('[inventory]', inventoryQuantity) : textStock  = window.inventory_text.hotStock.replace('[inventory]', inventoryQuantity);
            hotStockText.innerHTML = textStock;
            hotStockTextMobile.innerHTML = textStock;
            hotStock.classList.remove('is-hide');
            hotStockMobile.classList.remove('is-hide');
        } else {
            hotStock.classList.add('is-hide');
            hotStockMobile.classList.add('is-hide');
            
        }

        if (hotStock.matches('.style-2')) {
            const invenProgress = inventoryQuantity / maxStock * 100,
                hotStockProgressItem = hotStock.querySelector('.hotStock-progress-item');
            hotStockProgressItem.style.width = `${invenProgress}%`;
        }
    }
    const hasVariantInUrl = new URLSearchParams(window.location.search).has('variant');
    const hotStockElements = document.querySelectorAll('.productView .productView-hotStock');

    if (hotStockElements.length) {
      hotStockElements.forEach((hotStockEl, index) => {
        if (!hasVariantInUrl) {
          hotStockEl.classList.add('is-hide');
        }
      });
    }
}


function showWarning(content, time = null) {
    if (window.warningTimeout) {
        clearTimeout(window.warningTimeout);
    }
    const warningPopupContent = document.getElementById('halo-warning-popup').querySelector('[data-halo-warning-content]')
    warningPopupContent.textContent = content
    document.body.classList.add('has-warning')

    if (time) {
        window.warningTimeout = setTimeout(() => {
            document.body.classList.remove('has-warning')
        }, time)
    }
}

function getInputMessage(maxValue) {
    var message = window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', maxValue);
    return message
}

















































// class VariantSelects extends HTMLElement {
//     constructor() {
//         super();
//         this.item = $(this).closest('.productView');
//         this.isFullWidth = this.item.is('.layout-4');
//         console.log('Check 2');
//         this.onVariantInit();
//         this.addEventListener('change', this.onVariantChange.bind(this));
//     }

//     onVariantInit(){
//         this.updateOptions();
//         this.updateMasterId();
//         this.updateMedia(1500);
//         // this.updateURL();
//         this.renderProductAjaxInfo();
//         this.renderProductInfo();
//         if (!this.currentVariant) {
//             this.updateAttribute(true);
//         } else {
//             this.updateAttribute(false, !this.currentVariant.available);
//         }
//         this.updateVariantStatuses();
//     }
    
//     onVariantChange(event) {
//         this.updateOptions();
//         this.updateMasterId();
//         this.updatePickupAvailability();
//         this.updateVariantStatuses();
      
//         if (!this.currentVariant) {
//             this.updateAttribute(true);
//             this.updateStickyAddToCart(true);
//         } else {
//             this.updateMedia(200);
//             this.updateURL();
//             this.updateVariantInput();
//             this.renderProductAjaxInfo();
//             this.renderProductInfo();
//             this.updateProductInfo();
//             this.updateAttribute(false, !this.currentVariant.available);
//             this.updateStickyAddToCart(false, !this.currentVariant.available);
//             this.checkQuantityWhenVariantChange();
//         }
//     }

//     updateOptions() {
//         this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
//     }

//     decodeOptions() {
//         this.options = this.options.map(option => {
//             const parsedOption = this.decodeOption(option)
//             return parsedOption
//         })
//     }
  
//     decodeOption(option) {
//       if (option) {
//           return option.split('Special_Double_Quote').join('"').split('Special_Slash').join('/')
//         } else {
//           return null
//         }
//     }

//     encodeOption(option) {
//         if (option) {
//           return option.split('"').join('Special_Double_Quote').split('/').join('Special_Slash')
//         } else {
//           return null
//         }
//     }
    
//     updateMasterId() {
//         this.decodeOptions()
//         this.currentVariant = this.getVariantData().find((variant) => {
//             return !variant.options.map((option, index) => {
//                 return this.options[index] === option;
//             }).includes(false);
//         });
//     }      

//     updateMedia(time) {
//         if (!this.currentVariant || !this.currentVariant?.featured_media) return;
        
//         const newMedia = document.querySelectorAll(
//             `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
//         );

//         if (!newMedia) return;
//         window.setTimeout(() => {
//             $(newMedia).trigger('click');
//         }, time);

//         if (!this.isFullWidth || window.innerWidth < 768) return;

//         const mediaToReplace = document.querySelector('.productView-image[data-index="1"]');
//         const imageToReplace = mediaToReplace.querySelector('img')

//         if (!this.currentVariant) return;

//         const image = this.currentVariant?.featured_image;

//         if (image == null) return;

//         imageToReplace.setAttribute('src',  image.src)
//         imageToReplace.setAttribute('srcset', image.src)
//         imageToReplace.setAttribute('alt', image.alt)

//         if (mediaToReplace.getBoundingClientRect().top < window.scrollY) {
//             this.scrollToBlock(mediaToReplace)
//         }
//     }

//     scrollToBlock(block) {
//         const headerHeight = document.querySelectorAll('.section-header-navigation')[0]?.getBoundingClientRect().height 
//         const announcementBarHeight = document.querySelectorAll('.announcement-bar')[0]?.getBoundingClientRect().height 
//         const positionTop = block.getBoundingClientRect().top - headerHeight - announcementBarHeight 

//         window.scrollTo({
//             top: positionTop,
//             behavior: 'smooth'
//         })
//     }

//     updateURL() {
//         if (!this.currentVariant) return;
//         window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
//     }

//     updateVariantInput() {
//         const productForms = document.querySelectorAll(`#product-form-${this.dataset.product}, #product-form-installment-${this.dataset.product}`);

//         productForms.forEach((productForm) => {
//             const input = productForm.querySelector('input[name="id"]');
//             input.value = this.currentVariant.id;
//             input.dispatchEvent(new Event('change', { bubbles: true }));
//         });
//     }

//     updatePickupAvailability() {
//         const pickUpAvailability = document.querySelector('pickup-availability');
//         if (!pickUpAvailability) return;

//         if (this.currentVariant?.available) {
//             pickUpAvailability.fetchAvailability(this.currentVariant.id);
//         } else {
//             pickUpAvailability.removeAttribute('available');
//             pickUpAvailability.innerHTML = '';
//         }
//     }

//     renderProductAjaxInfo() {
//         fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
//             .then((response) => response.text())
//             .then((responseText) => {
//                 const id = `product-price-${this.dataset.product}`;
//                 const html = new DOMParser().parseFromString(responseText, 'text/html')
//                 const destination = document.getElementById(id);
//                 const source = html.getElementById(id);

//                 const property = `product-property-${this.dataset.product}`;
//                 const destinationProperty = document.getElementById(property);
//                 const sourceProperty = html.getElementById(property);

//                 if (source && destination) {
//                     destination.innerHTML = source.innerHTML;
//                 }

//                 if (this.checkNeedToConvertCurrency()) {
//                     let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');

//                     Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
//                 }

//                 if(destinationProperty) {
//                     if (sourceProperty) {
//                         destinationProperty.innerHTML = sourceProperty.innerHTML;
//                         destinationProperty.style.display = 'table';
//                     } else{
//                         destinationProperty.style.display = 'none';
//                     }
//                 } else if (sourceProperty) {
//                     document.querySelector('.productView-product').insertBefore(sourceProperty, document.querySelector('.productView-options'));
//                 }

//                 document.getElementById(`product-price-${this.dataset.product}`)?.classList.remove('visibility-hidden');
//         });
//     }

//     renderProductInfo() {
//         if(this.item.find('[data-sku]').length > 0){
//             this.item.find('[data-sku] .productView-info-value').text(this.currentVariant.sku);
//         }

//         var inventory = this.currentVariant?.inventory_management;

//         if(inventory != null) {
//             var arrayInVarName = `product_inven_array_${this.dataset.product}`,
//                 inven_array = window[arrayInVarName];

//             if(inven_array != undefined) {
//                 var inven_num = inven_array[this.currentVariant.id],
//                     inventoryQuantity = parseInt(inven_num);

//                 this.item.find('input[name="quantity"]').attr('data-inventory-quantity', inventoryQuantity);

//                 if(this.item.find('[data-inventory]').length > 0){
//                     if(inventoryQuantity > 0){
//                         const showStock = this.item.find('[data-inventory]').data('stock-level');
//                         if (showStock == 'show') {
//                             this.item.find('[data-inventory] .productView-info-value').text(inventoryQuantity+' '+window.inventory_text.inStock);
//                         }
//                         else {
//                             this.item.find('[data-inventory] .productView-info-value').text(window.inventory_text.inStock);
//                         }
//                     } else {
//                         this.item.find('[data-inventory] .productView-info-value').text(window.inventory_text.outOfStock);
//                     }
//                 }

//                 hotStock(inventoryQuantity);
//             }
//         }

//         if(this.item.find('.productView-stickyCart').length > 0){
//             const sticky = this.item.find('.productView-stickyCart');
//             const optionSticky = sticky.find('.select__select');

//             optionSticky.val(this.currentVariant.id);
//         }
//     }

//     updateProductInfo() {
//         fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
//             .then((response) => response.text())
//             .then((responseText) => {
//                 const description = `[data-product-description-${this.dataset.product}]`
//                 const html = new DOMParser().parseFromString(responseText, 'text/html')
//                 const destinationDesc = document.querySelector(description);
//                 const sourceDesc = html.querySelector(description);

//                 if (sourceDesc && destinationDesc) {
//                     destinationDesc.innerHTML = sourceDesc.innerHTML;
//                     if (destinationDesc.closest('.toggle-content--height')){
//                         destinationDesc.style.maxHeight = null;
//                     }
//                 }
//         });
//     }

//     updateAttribute(unavailable = true, disable = true){
//         let holidayModeElements = document.getElementsByClassName(`holiday-mode-wrapper`);
//         let holidayModeWrapper;
//         if(holidayModeElements.length > 0){
//           holidayModeWrapper = holidayModeElements[0];
//         }
//         //const holidayModeWrapper = document.getElementById(`holiday-mode-wrapper`);
//         const addButton = document.getElementById(`product-form-${this.dataset.product}`)?.querySelector('[name="add"]');
//         var quantityInput = this.item.find('input[name="quantity"]'),
//             notifyMe = this.item.find('.productView-notifyMe'),
//             hotStock = this.item.find('.productView-hotStock'),
//             buttonAddtocart = this.item.find('.product-form__submit'),
//             maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));

//         if (isNaN(maxValue)) {
//             maxValue = maxValue = parseInt(buttonAddtocart.attr('data-inventory-quantity'));
//         } else {
//             maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));
//         }
        
//         if(unavailable){
//             var text = window.variantStrings.unavailable;

//             quantityInput.attr('disabled', true);
//             notifyMe.slideUp('slow');
//             addButton.setAttribute('disabled', true);
//             addButton.textContent = text;
//             (holidayModeWrapper) ? holidayModeWrapper.style.display = "none" : null;
//             quantityInput.closest('quantity-input').addClass('disabled');

//             if(hotStock.length > 0) hotStock.addClass('is-hiden');
//         } else {
//             if (disable) {
//                 var text = window.variantStrings.soldOut;

//                 quantityInput.attr('data-price', this.currentVariant?.price);
//                 quantityInput.attr('disabled', true);
//                 addButton.setAttribute('disabled', true);
//                 addButton.textContent = text;
//                 (holidayModeWrapper) ? holidayModeWrapper.style.display = "none" : null;
//                 quantityInput.closest('quantity-input').addClass('disabled');

//                 if(notifyMe.length > 0){
//                     notifyMe.find('input[name="halo-notify-product-variant"]').val(this.currentVariant.title);
//                     notifyMe.find('.notifyMe-text').empty();
//                     notifyMe.slideDown('slow');
//                 }
//             } else{
//                 var text,
//                     subTotal = 0,
//                     price = this.currentVariant?.price;

//                 const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');
//                 const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');

//                 if(window.subtotal.show) {
//                     let qty = quantityInput.val();

//                     subTotal = qty * price;
//                     subTotal = Shopify.formatMoney(subTotal, window.money_format);
//                     subTotal = extractContent(subTotal);

//                     const moneySpan = document.createElement('span')
//                     moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal') 
//                     moneySpan.innerText = subTotal 
//                     document.body.appendChild(moneySpan) 

//                     if (this.checkNeedToConvertCurrency()) {
//                         let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
//                         Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
//                     }
                    
//                     subTotal = moneySpan.innerText 
//                     $(moneySpan).remove()

//                     if (window.subtotal.style == '1') {
//                         const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');
//                        if (pdView_subTotal != null) {
//                          pdView_subTotal.textContent = subTotal;
//                        }
                      
//                         if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
//                             text = window.variantStrings.preOrder;
//                         } else {
//                             text = window.variantStrings.addToCart;
//                         }
//                     }
//                     else if (window.subtotal.style == '2') {
//                         text = window.subtotal.text.replace('[value]', subTotal);
//                     }
//                 } else {
//                     subTotal = Shopify.formatMoney(price, window.money_format);
//                     subTotal = extractContent(subTotal);
//                     if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
//                         text = window.variantStrings.preOrder;
//                     } else {
//                         text = window.variantStrings.addToCart;
//                     }
//                 }

//                 quantityInput.attr('data-price', this.currentVariant?.price);
//                 quantityInput.attr('disabled', false);
//                 addButton.removeAttribute('disabled');
//                 addButton.textContent = text;
//                 (holidayModeWrapper) ? holidayModeWrapper.style.display = "block" : null;
//                 quantityInput.closest('quantity-input').removeClass('disabled');

//                 if (subTotal != 0 && stickyPrice.length) {
//                     stickyPrice.text(subTotal);
//                 }

//                 if (subTotal != 0 && stickyComparePrice.length && window.subtotal.show) {
//                     let comparePrice = $('[data-sticky-add-to-cart] .money-compare-price').data('compare-price'),
//                         qty = quantityInput.val();
//                     comparePrice = qty * comparePrice;
//                     comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
//                     comparePrice = extractContent(comparePrice);
//                     stickyComparePrice.text(comparePrice);
//                 }

//                 if(notifyMe.length > 0){
//                     notifyMe.slideUp('slow');
//                 }
//             }
//         }
//     }

//     updateStickyAddToCart(unavailable = true, disable = true){
//         if(this.item.find('.productView-stickyCart').length > 0){
//             const sticky = this.item.find('.productView-stickyCart');
//             const itemImage = sticky.find('.sticky-image');
//             const option = sticky.find('.select__select');
//             const input = document.getElementById(`product-form-sticky-${this.dataset.product}`)?.querySelector('input[name="id"]');
//             const button = document.getElementById(`product-form-sticky-${this.dataset.product}`)?.querySelector('[name="add"]');
//             var quantityInput = this.item.find('input[name="quantity"]');
//             var maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));
          
//             if(unavailable){
//                 var text = window.variantStrings.unavailable;

//                 button.setAttribute('disabled', true);
//                 button.textContent = text;
//             } else {
//                 if (!this.currentVariant) return;

//                 const image = this.currentVariant?.featured_image;
                
//                 if (image != null) {
//                     itemImage.find('img').attr({
//                         'src': image.src,
//                         'srcset': image.src,
//                         'alt': image.alt
//                     });
//                 }

//                 option.val(this.currentVariant.id);

//                 if (disable) {
//                     var text = window.variantStrings.soldOut;

//                     button.setAttribute('disabled', true);
//                     button.textContent = text;
//                 } else {
//                     if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
//                         text = window.variantStrings.preOrder;
//                     } else {
//                         text = window.variantStrings.addToCart;
//                     }

//                     button.removeAttribute('disabled');
//                     button.textContent = text;
//                 }

//                 input.value = this.currentVariant.id;
//                 input.dispatchEvent(new Event('change', { bubbles: true }));
//             }
//         }
//     }

//     getVariantData() {
//         this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
//         return this.variantData;
//     }

//     checkNeedToConvertCurrency() {
//         var currencyItem = $('.dropdown-item[data-currency]');
//         if (currencyItem.length) {
//             return (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
//         } else {
//             return;
//         }
//     }

//     checkQuantityWhenVariantChange() {
//         var quantityInput = this.closest('.productView-details').querySelector('input.quantity__input')
//         var maxValue = parseInt(quantityInput?.dataset.inventoryQuantity);
//         var inputValue = parseInt(quantityInput?.value);

//         let value = inputValue 

//         if (inputValue > maxValue && maxValue > 0) {
//             value = maxValue
//         } else {
//             value = inputValue
//         }

//         if (value < 1 || isNaN(value)) value = 1 
      
//         if (quantityInput) {
//           quantityInput.value = value
//         }
      
//         document.getElementById('product-add-to-cart').dataset.available = this.currentVariant.available && maxValue <= 0
//     }

//     updateVariantStatuses() {
//         // const options = this.item.find('.productView-details .product-form__input'),
//         //     optionsLength = options.length,
//         //     pvOptionsLength = PVoptions.length,
//         //     checkStickyVariant = false;
      
//         // optionsLength > pvOptionsLength ? checkStickyVariant = true : '';

//         const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
//         const inputWrappers = [...this.querySelectorAll('.product-form__input')];
//         const inputLength = inputWrappers.length;
//         inputWrappers.forEach((option, index) => {
//             option.querySelector('[data-header-option]').innerText = option.querySelector(':checked').value;
//             if (index === 0 && inputLength > 1) return;
//             const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
//             const previousOptionSelected = inputLength > 1 ? inputWrappers[index - 1].querySelector(':checked').value : inputWrappers[index].querySelector(':checked').value;
//             const optionInputsValue = inputLength > 1 ? selectedOptionOneVariants.filter(variant => variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]) : this.variantData.map(variantOption => variantOption[`option${ index + 1 }`]);
//             const availableOptionInputsValue = inputLength > 1 ? selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]) : this.variantData.filter(variant => variant.available).map(variantOption => variantOption[`option${ index + 1 }`]);
//             this.setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue)
//         });
//     }

//     setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue) {
//         optionInputs.forEach(input => {
//             if (availableOptionInputsValue.includes(input.getAttribute('value'))) {
//                 input.classList.remove('soldout');
//                 input.innerText = input.getAttribute('value');
//             } else {
//                 input.classList.add('soldout');
//                 optionInputsValue.includes(input.getAttribute('value')) ? input.innerText = input.getAttribute('value') + ' (Sold out)' : input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'))
//             }
//         });
//     }
// }

// customElements.define('variant-selects', VariantSelects);

// class VariantRadios extends VariantSelects {
//     constructor() {
//         super();
//     }

//     setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue) {
//         optionInputs.forEach(input => {
//             if (availableOptionInputsValue.includes(input.getAttribute('value'))) {
//                 input.nextSibling.classList.remove('soldout', 'unavailable');
//                 input.nextSibling.classList.add('available');
//             } else {
//                 input.nextSibling.classList.remove('available', 'unavailable');
//                 input.nextSibling.classList.add('soldout');

//                 if (window.variantStrings.hide_variants_unavailable && !optionInputsValue.includes(input.getAttribute('value'))) {
//                     input.nextSibling.classList.add('unavailable')
//                     if (!input.checked) return;
//                     let inputsValue;
//                     availableOptionInputsValue.length > 0 ? inputsValue = availableOptionInputsValue : inputsValue = optionInputsValue;
//                     input.closest('.product-form__input').querySelector(`input[value="${inputsValue[0]}"]`).checked = true;
//                     this.dispatchEvent(new Event('change'))
//                 }
//             }
//         });
//     }
        
//     updateOptions() {
//         const fieldsets = Array.from(this.querySelectorAll('fieldset'));
//         this.options = fieldsets.map((fieldset) => {
//             return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
//         });
//     }
// }

// customElements.define('variant-radios', VariantRadios);

// class QuantityInput extends HTMLElement {
//     constructor() {
//         super();
//         this.input = this.querySelector('input');
//         this.changeEvent = new Event('change', { bubbles: true });
//         this.input.addEventListener('change', this.onInputChange.bind(this));

//         this.querySelectorAll('button').forEach(
//             (button) => button.addEventListener('click', this.onButtonClick.bind(this))
//         );

//         if (!this.checkHasMultipleVariants()) {
//             this.initProductQuantity();
//             this.checkVariantInventory();
//         }
//     }

//     onInputChange(event) {
//         event.preventDefault(); 
//         var inputValue = this.input.value;
//         var maxValue = parseInt(this.input.dataset.inventoryQuantity);
//         var currentId = document.getElementById(`product-form-${this.input.dataset.product}`)?.querySelector('[name="id"]')?.value;
//         var saleOutStock  = document.getElementById('product-add-to-cart').dataset.available === 'true' || false ;
//         const addButton = document.getElementById(`product-form-${this.input.dataset.product}`)?.querySelector('[name="add"]');

//         if(inputValue < 1) {
//             inputValue = 1;

//             this.input.value =  inputValue;
//         }
        
//         if (inputValue > maxValue && !saleOutStock && maxValue > 0) {
//             var arrayInVarName = `selling_array_${this.input.dataset.product}`,
//                 itemInArray = window[arrayInVarName],
//                 itemStatus = itemInArray[currentId];
          
//             if(itemStatus == 'deny') {
//               inputValue = maxValue
//               this.input.value = inputValue;
//               const message = getInputMessage(maxValue)
//               showWarning(message, 3000)
//             }
//         } else if (inputValue > maxValue && saleOutStock && maxValue <= 0) {
//             this.input.value = inputValue;
//         }

//         if(window.subtotal.show) {
//             var text,
//                 price = this.input.dataset.price,
//                 subTotal = 0;

//             var parser = new DOMParser();

//             subTotal = inputValue * price;
//             subTotal = Shopify.formatMoney(subTotal, window.money_format);
//             subTotal = extractContent(subTotal);

//             const moneySpan = document.createElement('span')
//             moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal') 
//             moneySpan.innerText = subTotal 
//             document.body.appendChild(moneySpan) 

//             if (this.checkNeedToConvertCurrency()) {
//                 let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
//                 Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
//             }

//             subTotal = moneySpan.innerText 
//             $(moneySpan).remove()

//             if (window.subtotal.style == '1') {
//                 const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');

//                 pdView_subTotal.textContent = subTotal;
//             }
//             else if (window.subtotal.style == '2') {
//                 text = window.subtotal.text.replace('[value]', subTotal);

//                 addButton.textContent = text;  
//             }

//             const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');
//             const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');

//             if (stickyPrice.length) {
//                 stickyPrice.text(subTotal);
//             }

//             if (stickyComparePrice.length && window.subtotal.show) {
//                 let comparePrice = $('[data-sticky-add-to-cart] .money-compare-price').data('compare-price');
//                 comparePrice = inputValue * comparePrice;
//                 comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
//                 comparePrice = extractContent(comparePrice);
//                 stickyComparePrice.text(comparePrice);
//             }
//         }

//         if (this.classList.contains('quantity__group--2') || this.classList.contains('quantity__group--3')) {
//             const mainQty = document.querySelector('.quantity__group--1 .quantity__input');
//             mainQty.value = inputValue;

//             const mainQty2Exists = !!document.querySelector('.quantity__group--2 .quantity__input');
//             const mainQty3Exists = !!document.querySelector('.quantity__group--3 .quantity__input');

//             if (this.classList.contains('quantity__group--2') && mainQty3Exists) {
//                 const mainQty3 = document.querySelector('.quantity__group--3 .quantity__input');
//                 mainQty3.value = inputValue;
//             }
//             else if (this.classList.contains('quantity__group--3') && mainQty2Exists) {
//                 const mainQty2 = document.querySelector('.quantity__group--2 .quantity__input');
//                 mainQty2.value = inputValue;
//             }
//         }
//     }

//     onButtonClick(event) {
//         event.preventDefault();
//         const previousValue = this.input.value;
        
//         event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
//         if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
//     }

//     checkNeedToConvertCurrency() {
//         return (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
//     }
    
//     checkHasMultipleVariants() {
//         const arrayInVarName = `product_inven_array_${this.querySelector('[data-product]').dataset.product}`
//         this.inven_array = window[arrayInVarName];
//         return Object.keys(this.inven_array).length > 1
//     }
        
//     initProductQuantity() {
//         if(this.inven_array != undefined) {
//             var inven_num = Object.values(this.inven_array),
//                 inventoryQuantity = parseInt(inven_num);

//             this.querySelector('input[name="quantity"]').setAttribute('data-inventory-quantity', inventoryQuantity);
//             this.querySelector('input[name="quantity"]').dataset.inventoryQuantity = inventoryQuantity
//         }
//     }

//     checkVariantInventory() {
//         const addBtn = document.getElementById('product-add-to-cart')
//         this.input.disabled = addBtn.disabled 
//         this.querySelector('.btn-quantity.minus').disabled = addBtn.disabled
//         this.querySelector('.btn-quantity.plus').disabled = addBtn.disabled
//     }

//     getVariantData() {
//         this.variantData = this.variantData || JSON.parse(document.querySelector('.product-option [type="application/json"]').textContent);
//         return this.variantData;
//     }
// }

// customElements.define('quantity-input', QuantityInput);

// function hotStock(inventoryQuantity) {
//     const productView = document.querySelector('.productView');
//     const hotStock = productView.querySelector('.productView-hotStock');
//     if(hotStock) {
//         let hotStockText = hotStock.querySelector('.hotStock-text'),
//             maxStock = parseFloat(hotStock.dataset.hotStock),
//             textStock;

//         if(inventoryQuantity > 0 && inventoryQuantity <= maxStock){
//             hotStock.matches('.style-2') ? textStock  = window.inventory_text.hotStock2.replace('[inventory]', inventoryQuantity) : textStock  = window.inventory_text.hotStock.replace('[inventory]', inventoryQuantity);
//             hotStockText.innerHTML = textStock;
//             hotStock.classList.remove('is-hide');
//         } else {
//             hotStock.classList.add('is-hide');
//         }

//         if (hotStock.matches('.style-2')) {
//             const invenProgress = inventoryQuantity / maxStock * 100,
//                 hotStockProgressItem = hotStock.querySelector('.hotStock-progress-item');
//             hotStockProgressItem.style.width = `${invenProgress}%`;
//         }
//     }
// }
// const hotStockNoOptions = document.querySelector('.productView .productView-hotStock[data-current-inventory]');
// if (hotStockNoOptions) {
//     const inventoryQuantity = parseFloat(hotStockNoOptions.dataset.currentInventory);
//     hotStock(inventoryQuantity);
// }


// function showWarning(content, time = null) {
//     if (window.warningTimeout) {
//         clearTimeout(window.warningTimeout);
//     }
//     const warningPopupContent = document.getElementById('halo-warning-popup').querySelector('[data-halo-warning-content]')
//     warningPopupContent.textContent = content
//     document.body.classList.add('has-warning')

//     if (time) {
//         window.warningTimeout = setTimeout(() => {
//             document.body.classList.remove('has-warning')
//         }, time)
//     }
// }

// function getInputMessage(maxValue) {
//     var message = window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', maxValue);
//     return message
// }
